import React, { useState } from 'react'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/fancy-example.css'
import AutoSuggestionInputCast from './AutoSuggestionInput'
// import AutoSuggestionInputDirector from './listMoviesAutoSuggestionInputs/AutoSuggestionInputDirector'
import AutoSuggestionInputCrew from './listMoviesAutoSuggestionInputs/AutoSuggestionInputCrew'
// import AutoSuggestionInputMusicBy from './listMoviesAutoSuggestionInputs/AutoSuggestionInputMusicBy'
// import AutoSuggestionInputCenimatography from './listMoviesAutoSuggestionInputs/AutoSuggestionInputCenimatography'
// import AutoSuggestionInputEditedBy from './listMoviesAutoSuggestionInputs/AutoSuggestionInputEditedBy'
// import AutoSuggestionInputDialogBy from './listMoviesAutoSuggestionInputs/AutoSuggestionInputDialogBy'
import ConditionalHtml from './ConditionalHtml'

export default function PersonFilterAccordian(props) {
  const [showConditionUicrew, setshowConditionUicrew] = useState(false)
  const [conditionForCrewFilter, setconditionForCrewFilter] = useState('OR')
  const [crewProfectionlName, setCrewProfectionlName] = useState()
  const [showConditionUi, setshowConditionUi] = useState(false)
  const [conditionForCastFilter, setconditionForCastFilter] = useState('OR')
  // const [handleCastTrueOrFalse, sethandleCastTrueOrFalse] = useState(false)
  // const [handleCrewTrueOrFalse, sethandleCrewTrueOrFalse] = useState(false)
  const [castArraySelectedNames, setCastArraySelectedNames] = useState([])
  const [crewArraySelectedNames, setCrewArraySelectedNames] = useState([])

  // const [handleCast, sethandleCast] = useState(false)
  // const [handleCrew, sethandleCrew] = useState(false)

  // const { isExpandAll /* , setExpandAll */ } = props
  // console.log(props.SearchPerson, 'props.SearchPersonprops.SearchPerson')
  // const [isExpandAll, setExpandAll] = useState(true)
  // const openCastAccordian = () => {
  //   sethandleCastTrueOrFalse(!handleCastTrueOrFalse)
  //   sethandleCast(!handleCast)
  //   handleExpandCastAccordian()
  // }

  // const openCrewAccordian = () => {
  //   sethandleCrewTrueOrFalse(!handleCrewTrueOrFalse)
  //   sethandleCrew(!handleCrew)
  //   handleExpandCrewAccordian()
  // }

  // const handleExpandCastAccordian = () => {
  //   setExpandAll({ castAccordian: !handleCast, crewAccordian: handleCrewTrueOrFalse })
  // }

  // const handleExpandCrewAccordian = () => {
  //   setExpandAll({ castAccordian: handleCast, crewAccordian: !handleCrewTrueOrFalse })
  // }

  // console.log(props.PersonCrewFilterData, 'ccccdatadatadatadatadata==========')

  const handleSelectCondition = e => {
    const data = e.target.value
    // console.log(data, 'daatttttttttttttttttttt')
    setconditionForCastFilter(data)
    // props.conditionBasedFilterCast(data)

    setshowConditionUi(false)
    props.PersonCrewFilterData(castArraySelectedNames, 'cast_En', 'castFilterBy', data)

    // console.log(data, 'valkueeeeeeeeeeeeeeeeee')
  }

  const handleSelectConditionCrew = e => {
    const data = e.target.value

    console.log(data, 'conditionForCrewFilterconditionForCrewFilter')
    props.PersonCrewFilterData(crewArraySelectedNames, crewProfectionlName, 'crewFilterBy', data)

    // props.conditionBasedFilterCastORCrew(crewArraySelectedNames, 'crewFilterBy', data)
    setconditionForCrewFilter(data)

    setshowConditionUicrew(false)
    // props.conditionBasedFilterCrew(data)
    console.log(data, 'valkueeeeeeeeeeeeeeeeee')
  }

  const handleCondition = () => {
    setshowConditionUi(true)
    props.PersonCrewFilterData(
      castArraySelectedNames,
      'cast_En',
      'castFilterBy',
      conditionForCastFilter,
    )
  }

  const handleConditionCrew = () => {
    setshowConditionUicrew(true)
  }

  // console.log(isExpandAll, 'isExpandAllisExpandAll')
  return (
    <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
      <AccordionItem
      // onClick={() => openCastAccordian()}
      // dangerouslySetExpanded={isExpandAll.castAccordian}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Cast</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ConditionalHtml
            handleCondition={handleCondition}
            conditionForCastFilter={conditionForCastFilter}
            showConditionUi={showConditionUi}
            handleSelectCondition={handleSelectCondition}
          />
          <div className='d-flex items-center gap-2 m-2'>
            <lable style={{ width: '25%' }}>
              <b>Cast</b>
            </lable>
            :
            <div className='d-flex gap-2 m-2 items-center' style={{ width: '80%' }}>
              <AutoSuggestionInputCast
                selectedCastData={props.selectedCastData}
                setSelectedCastData={props.setSelectedCastData}
                setCastArraySelectedNames={setCastArraySelectedNames}
                setshowConditionUi={setshowConditionUi}
                conditionForCastFilter={conditionForCastFilter}
                SearchPerson={props.SearchPersonCast}
                setSearchPerson={props.setSearchPersonCast}
                statusType={props.statusType}
                PersonCastFilter={props.PersonCrewFilterData}
              />
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem
      // dangerouslySetExpanded={isExpandAll.crewAccordian}
      // onClick={() => openCrewAccordian()}
      >
        <AccordionItemHeading>
          <AccordionItemButton>Crew</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ConditionalHtml
            handleCondition={handleConditionCrew}
            conditionForCastFilter={conditionForCrewFilter}
            showConditionUi={showConditionUicrew}
            handleSelectCondition={handleSelectConditionCrew}
          />
          <div>
            <div className='d-flex items-center gap-2 m-2'>
              <lable style={{ width: '25%' }}>
                <b>Produced By</b>
              </lable>
              :
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  selectedCastData={props.selectedCrewProd}
                  setSelectedCastData={props.setselectedCrewProd}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                  SearchPerson={props.SearchPersonProd}
                  setSearchPerson={props.setSearchPersonProd}
                  ResetAccordianData={props.ResetAccordianData}
                  crewName='producedBy_En'
                  statusType={props.statusType}
                  PersonCrewFilter={props.PersonCrewFilterData}
                />
              </div>
            </div>
            <div className='d-flex items-center gap-2 m-2'>
              <lable style={{ width: '25%' }}>
                <b>Directed By</b>
              </lable>
              :{' '}
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  setSelectedCastData={props.setSelectedCrewDirector}
                  selectedCastData={props.selectedCrewDirector}
                  SearchPerson={props.SearchPerson}
                  setSearchPerson={props.setSearchPerson}
                  ResetAccordianData={props.ResetAccordianData}
                  crewName='directedBy_En'
                  statusType={props.statusType}
                  PersonCrewFilter={props.PersonCrewFilterData}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                />
              </div>
            </div>
            <div className='d-flex items-center gap-2 m-2'>
              <lable style={{ width: '25%' }}>
                <b>movieMusicBy</b>
              </lable>
              :{' '}
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  setSelectedCastData={props.setselectedCrewMusic}
                  selectedCastData={props.selectedCrewMusic}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                  SearchPerson={props.SearchPersonMusic}
                  setSearchPerson={props.setSearchPersonMusic}
                  crewName='musicBy_En'
                  statusType={props.statusType}
                  PersonCrewFilter={props.PersonCrewFilterData}
                />
              </div>
            </div>
            <div className='d-flex items-center gap-2 m-2'>
              <lable style={{ width: '25%' }}>
                <b>movieCinematography</b>
              </lable>
              :{' '}
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  selectedCastData={props.selectedCrewCenimato}
                  setSelectedCastData={props.setselectedCrewCenimato}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                  SearchPerson={props.SearchPersonCenimato}
                  setSearchPerson={props.setSearchPersonCenimato}
                  crewName='cinematography_En'
                  statusType={props.statusType}
                  PersonCrewFilter={props.PersonCrewFilterData}
                />
              </div>
            </div>
            <div className='d-flex items-center gap-2 m-2 '>
              <lable style={{ width: '25%' }}>
                <b>movieEditedBy</b>
              </lable>
              :{' '}
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  setSelectedCastData={props.setselectedCrewEditor}
                  selectedCastData={props.selectedCrewEditor}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                  SearchPerson={props.SearchPersonEditor}
                  setSearchPerson={props.setSearchPersonEditor}
                  crewName='editedBy_En'
                  statusType={props.statusType}
                  PersonCrewFilter={props.PersonCrewFilterData}
                />
              </div>
            </div>
            <div className='d-flex items-center gap-2 m-2'>
              <lable style={{ width: '25%' }}>
                <b>movieDialogueBy</b>
              </lable>
              :{' '}
              <div style={{ width: '80%' }}>
                <AutoSuggestionInputCrew
                  setSelectedCastData={props.setSelectedCrewDialog}
                  selectedCastData={props.selectedCrewDialog}
                  setCrewProfectionlName={setCrewProfectionlName}
                  crewArraySelectedNames={crewArraySelectedNames}
                  setCrewArraySelectedNames={setCrewArraySelectedNames}
                  PersonCrewFilter={props.PersonCrewFilterData}
                  SearchPerson={props.SearchPersonDialog}
                  setSearchPerson={props.setSearchPersonDialog}
                  crewName='dialogueBy_En'
                  statusType={props.statusType}
                />
              </div>
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}
